export function errorHandler(error: any): never {
  if (error?.response?.data?.message) {
    throw new Error(String(error?.response?.data?.message));
  }
  throw error;
}
